import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { useConfirmModalKeys } from "@/hooks/use-confirm-modal-keys";
import { popModal, pushModal, useModalStore } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

interface MisclickConfirmModalProps {
  title: string;
  description: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
}

/** 되돌릴 수 없는 태깅 일괄 작업 전에 한 번 더 묻는 오클릭 방지 팝업. */
export const MisclickConfirmModal = ({
  title,
  description,
  confirmLabel,
  onConfirm,
}: MisclickConfirmModalProps) => {
  const handleConfirm = () => {
    popModal();
    onConfirm();
  };

  const modalRef = useConfirmModalKeys(handleConfirm);

  return (
    <ModalWrapper
      ref={modalRef}
      className="flex w-[458px] flex-col gap-0 rounded-[8px] border border-line-normal bg-white p-0 shadow-xxlarge"
    >
      <h2 className="px-6 pt-5 label-1-normal-semibold text-label-normal">
        {title}
      </h2>
      <p className="px-6 py-4 label-2-medium text-label-alternative">
        {description}
      </p>
      <div className="flex justify-end gap-2 px-6 pb-5">
        <Button variant="outlined" size={36} onClick={popModal}>
          취소
        </Button>
        {/* 열릴 때 확인 버튼에 포커스 — Enter 로도 확인되게. (ModalStack 이 Radix 의
            자동 포커스를 막아둬서 여기서 직접 준다.) */}
        <Button
          autoFocus
          variant="solid"
          color="negative"
          size={36}
          onClick={handleConfirm}
        >
          {confirmLabel}
        </Button>
      </div>
    </ModalWrapper>
  );
};

/** 열려 있는 다른 모달을 모두 닫고 띄운다 — 다른 모달 위에 겹쳐 뜨지 않게 한다. */
export const pushMisclickConfirmModal = (props: MisclickConfirmModalProps) => {
  useModalStore.getState().modals.clear();
  pushModal(MisclickConfirmModal, props);
};
